import {
    DATIQ_DEFAULT_EMPTY_LABEL,
    DATIQ_DEFAULT_ID,
    DATIQ_DEFAULT_STRING,
} from './datiq-app-default-values';
import { IDatiqUnavButton } from './datiq-unav-button.interface';

export const emptyDatiqUnavButton: IDatiqUnavButton = {
    id: DATIQ_DEFAULT_ID('button-'),
    label: DATIQ_DEFAULT_EMPTY_LABEL,
    action: { name: DATIQ_DEFAULT_STRING },
};
